<template>
  <v-container fill-height align-center>
    <v-layout align-center justify-center>
      <v-progress-circular v-if="loading" indeterminate color="primary" />
    </v-layout>
  </v-container>
</template>

<script>
import router from '@/router';

export default {
  name: 'Index',
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    base_domain: () => {
      const path =
        window.location.pathname === '/app/index.html' ? '/app/index.html' : '';
      if (window.location.port) {
        return `${window.location.protocol}//${window.location.hostname}:${window.location.port}${path}`;
      }
      return `${window.location.protocol}//${window.location.hostname}${path}`;
    },
  },
  methods: {
    login() {
      const url = '/sso/login';

      this.$http
        .get(url, {
          params: {
            "json": 1,
            redirect_uri: `${this.base_domain}`,
          },
        })
        .then(res => {
          console.log(res.data);
          const redirectUrl = res.data.redirect_url;
          this.loading = false;
          window.location = redirectUrl;
        });
    },
  },
  async created() {
    // check if there's a session by calling login server and get identity
    let redirect = '/';
    if (localStorage.getItem('redirect_url')) {
      redirect = localStorage.getItem('redirect_url');
      localStorage.removeItem('redirect_url');
    } else if (this.$route.query.redirect) {
      redirect = this.$route.query.redirect;
    }

    try {
      const res = await this.$http.get('/api/user');
      this.$store.commit('USER_LOGIN', res.data.user, res.headers.logout_out_in);
      router.push(redirect).catch(err => {console.log(err)})
    } catch (e) {
      console.log('Err: redirect', redirect);
      localStorage.setItem('redirect_url', redirect);
      this.$store.commit('USER_LOGOUT');
      this.login();
    }
  },
};
</script>